import terms from './terms-fr';
import policy from './policy-fr';

export default {
  emailAddress: 'Email',
  confimEmailAddress: "Confirmer l'adresse email",
  password: 'Mot de passe',
  confimPassword: 'Confirmer le mot de passe',
  changePassword: 'Changer le mot de passe',
  register: "S'inscrire",
  accountExists: 'Un compte avec cet identifiant existe déjà',
  forgotPassword: 'Mot de passe oublié?',
  registedGoTologin: 'Déjà Enregistré ? Se connecter',
  successfulRegistration: "L'inscription est réussit.",
  activationtEmailSent:
    "Un email d'activation a été envoyé à l'adresse email enregistrée",
  continue: 'Continuer',
  email: 'Email',
  login: ' Se connecter',
  info:
    'Le Burkina Faso d’eVisa est une autorisation électronique de voyage émise par le gouvernement du Burkina Faso. Les visiteurs qui entrent dans Burkina Faso doivent présenter un visa électronique valide au port d’entrée.',
  application: 'Demande',
  submitDocs: 'Soumission de documents',
  privacyPayment: 'Paiement',
  approval: 'Approbation',
  termsAndConditions: 'Termes et Conditions',
  privacyPolicy: 'Politique de confidentialité',
  ministry: '© {{year}} eVisa-ministère de la sécurité',
  registerYet: 'Pas encore inscrit?',
  alreadyRegistered: 'Déjà inscrit ?',
  newApplication: 'Nouvelle demande',
  myApplications: 'Mes demandes',
  applicationId: 'Reference',
  applicationName: 'Demandeur',
  status: 'Statut',
  submissionDate: 'Date soumission',
  actions: 'Actions',
  view: 'Vue',
  resume: 'Continuer',
  respondToVisaOfficer: "Répondre à l'agent des visas",
  messageToApplicant: 'Message au Demandeur',
  applicationForm: 'Formulaire de demande',
  back: 'Retour',
  backTo: 'Liste des demandes',
  saveAndContinue: 'Sauvegarder et Continuer',
  supportingDocs: 'Pièces justificatives',
  docType: 'Type de document',
  filename: 'Nom de fichier',
  uploadMax: 'Télécharger',
  declarationAndPayment: 'Déclaration et paiement',
  proceedTo: 'Procéder au paiement',
  declarationOfApplicant: 'Déclaration du demandeur',
  checkBox1:
    "Je déclare l'exactitude des informations portées sur cette demande et je prends la responsabilité des erreurs de saisie.",
  checkBox2: "Je suis informé que les frais de visa ne sont pas remboursables en cas de refus. Voir ",
  checkBox2And: ' et',
  secureCardPayment: 'Sélectionnez le mode de paiement',
  submitPayment: 'Procéder au paiement',
  summary: 'Résumé :',
  firstName: 'Prénom :',
  familyName: 'Nom :',
  passportNumber: 'Numéro de Passeport :',
  paymentReceiptNumber: 'Numéro de Reçu de Paiement',
  payment: 'Paiement :',
  totalAmount: 'Somme totale :',
  paymentNotSuccessful: "Le paiement n'est pas réussi",
  pleaseGoBack:
    "Retournez s'il vous plaît aux options de paiement et choisissez une autre méthode",
  goToApplications: 'Accéder aux demandes',
  paymentSuccessful: 'Paiement réussi.',
  applicationSuccessful: "L'application est réussie",
  applicationSubmitted:
    'Votre demande de visa a été soumise avec succès au responsable des visas pour examen et approbation. Vous recevrez un courriel vous informant du résultat une fois que le visa aura été traité.',
  shortcode: 'Code Court:',
  print: 'Impression',
  whatsNext: 'Et après?',
  applicationTracked:
    'Le statut de votre demande peut être consulté en accédant à la page du liste des demandes',
  visaDetails: 'Informations générales',
  personalDetails: 'Informations personnelles',
  passportDetails: 'Informations du passeport',
  travelDetails: 'Informations sur le voyage',
  contactDetails: 'Détails de contact',
  address: 'Adresse',
  homeAddress: 'Adresse personnelle',
  emergencyContact: "Contact d'urgence",
  paymentSubtitle: 'Paiement',
  visaFee: 'Frais de Visa :',
  totalAmount2: 'Somme totale',
  send: 'Envoyer',
  passwordSuccessfullyChanged: 'Votre mot de passe a été modifié avec succès',
  ok: 'Ok',
  emailResetPassword:
    'Un email vous a été envoyé avec les instructions pour réinitialiser votre mot de passe.',
  visaType: 'Type de visa',
  visaPurpose: 'Objet du visa',
  nationality: 'Nationalité',
  surname: 'Nom',
  firstGivenNames: 'Prénom',
  dateBirth: 'Date de naissance',
  gender: 'Sexe',
  countryBirth: 'Pays de naissance',
  cityBirth: 'Ville de naissance',
  relantionship: 'Etat civil',
  occupation: 'Profession',
  numberChildren: 'Nombre d’enfants',
  passportNumber2: 'Numéro de passeport',
  placeIssue: "Lieu d'émission",
  passportType: 'Type de passeport',
  passportExpiry: "Date d'expiration du passeport",
  passportIssue: "Date d'émission",
  portEntry: 'Point d’entrée',
  intendedDate:
    "Date d'entrée prévue (7 jours avant la date d'entrée prévue)",
  maximumStay: 'Durée de séjour (jours)',
  destinationAddress: 'Nom du correspondant au',
  nameAndNumberIn:
    'Nom, prénom et numéro de téléphone du correspondant au',
  modesTransport: 'Mode de transport',
  destinations: 'Ville de destination',
  mobileCellPhone: 'Téléphone portable',
  email2: 'Email',
  street: 'Rue',
  city: 'Ville',
  state: 'Region',
  postalCode: 'Adresse postal',
  countryResidence: 'Pays de résidence',
  fullName: 'Nom',
  phoneNumber: 'Numéro de téléphone',
  paymentMethod: 'Méthodes de payement',
  payment_method: 'Mode de Paiement',
  paidAt: 'Date de paiement',
  submitter: 'Soumissionnaire',
  cardName: 'Nom du titulaire',
  cardNumber: 'Numéro de carte',
  expirationDate: "Date d'expiration :",
  month: 'Mois',
  year: 'Année',
  cvv: 'CVV',
  unspecified: 'Non Spécifié',
  supportingDocumentsCaption:
    "Les documents marqués d'un '*' sont obligatoires.",
  maxFileSizeSupporting:
    "Fournissez l'un des types de fichiers image suivants : JPG, JPEG, PNG, TIFF, BMP, DOC, DOCX, PDF jusqu'à 1 MB",
  eitherOrDocSelectionPrompt: 'Sélectionnez le type de document',
  cancel: 'Annuler',
  or: 'OU',
  close: 'Fermer',
  expiredSessionTitle: 'Votre session a expiré',
  expiredSessionText: 'Votre session a expiré. Veuillez vous reconnecter',
  404: "La page que vous recherchez n'a pas été trouvée.",
  home: 'Accueil',
  onlineServices: 'Service de Visa En ligne',
  eVisa: 'eVisa',
  enterEmailAddress: 'Entrez votre adresse email',
  resetPassword: 'Réinitialiser votre mot de passe',
  applicationID: 'Reference :',
  shortCode: 'Code Court de la Demande',
  uploadPaymentReceiptScan: 'Télécharger le Scan des reçus de paiement *',
  applicationDate: 'Date de la Demande :',
  applicationNAME: 'Demandeur :',
  visaP: 'But de Visa :',
  startWritingResponse: 'Commencez à écrire ici',
  hotelOrContact: "Nom de l'hôtel ou du contact",
  passwordResetConfirmation: 'Votre mot de passe a été réinitialisé',
  resetPasswordNewPasswordTitle: 'Créer nouveau mot de passe',
  requestResetPasswordTitle: 'Réinitialiser le mot de passe',
  registrationTitle: 'Enregistrement',
  awaitingFeedbackTitle: 'En attente de commentaires',
  logInTitle: ' Se connecter',
  applicationSummaryTitle: 'Demande sommaire',
  unableToLogin: 'Connection impossible',
  pageNotFound: "La page que vous recherchez n'a pas été trouvée.",
  yourApplicationID: 'Reference:',
  emailSentTo: 'Un email a été envoyé à ',
  withApplicationID: ' avec Reference',
  unknownError: "Une erreur inconnue s'est produite",
  SERVER_ERROR: 'Une erreur de serveur inconnu s’est produite.',
  TIMEOUT_ERROR:
    'Un délai d’attente s’est produite alors qu’il tentait de se connecter au serveur.',
  CONNECTION_ERROR: 'Impossible de se connecter au serveur.',
  NETWORK_ERROR:
    'Impossible de se connecter au serveur en raison d’une erreur de réseau.',
  CANCEL_ERROR: 'Demande annulée',
  supportingTypesCaption:
    'Seuls les fichiers avec des extensions (.doc/.pdf/.jpg) sont acceptés',
  mustBeAfterToday: 'Veuillez saisir une date valide',
  mustBeOnOrAfterToday: 'Veuillez saisir une date valide',
  mustBeOnOrBeforeToday: 'Veuillez saisir une date valide',
  attachedFiles: 'Fichiers joints',
  chooseFile: 'Choisir le fichier',
  unsupportedDocType:
    'Format de fichier non supporté. Les formats suivants sont pris en charge : {{fileTypes}}',
  unsupportedImageFileType:
    'Format de fichier non supporté. Les formats suivants sont pris en charge : {{pictureFileTypes}}',
  imageFileTypeLabel:
    'Les documents aux formats suivants peuvent être téléchargés : {{pictureFileTypes}}. La taille maximale des fichiers est de 1Mo.',
  fileTypeLabel:
    'Les documents aux formats suivants peuvent être téléchargés : {{fileTypes}}. La taille maximale des fichiers est de 1Mo.',
  maxFileSizeExceeded:
    'La taille maximale du fichier est dépassée. Veuillez vous assurer que le fichier ne dépasse pas 1 Mo.',
  mustBeBeforePassportExpireDate:
    "La date doit être avant la date d'expiration du passeport",
  clear: 'Effacer',
  apply: 'Appliquer',
  sendPaymentLink: 'Envoyer le Lien de Paiement',
  paymentLinkSent: 'Lien de paiement envoyé au demandeur',
  pleaseWait: 'Veuillez patienter',
  serviceFee: 'Frais de service: {{amount}} {{currency}}',
  costOfVisa: 'Coût du visa: {{amount}} {{currency}}',
  totalPaymentAmount: 'Montant Total du Paiement: {{amount}} {{currency}}',
  'Pay at Embassy': 'Payer à l’Ambassade',
  rowsPerPage: 'Lignes par page',
  finishPay: 'Appliquer le paiement',
  diplomaticMission: 'Organisme diplomatique',
  filter: {
    shortCode: 'Code court',
    lastName: 'Nom',
    status: 'Statut',
    submitter: 'Soumis Par',
    visaForLocalPayment: 'Visas pour paiement local',
    submittedDateFrom: 'Date de soumission de',
    submittedDateTo: 'Date de soumission a',
  },
  paymentInfo: {
    header: 'Paiement en attente',
    appId: 'Numéro de la demande: ',
    description:
      "Après le paiement des frais de visa, votre demande sera traitée. Veuillez vous rendre à l'ambassade ou à la mission diplomatique la plus proche de chez vous et payer la demande.",
    additional: 'Vous devrez présenter les informations suivantes:',
  },
  downloadPDF: 'Prévisualiser la demande en PDF',
  confirmPDF:
    "Je confirme que j'ai examiné la version PDF de ma demande, en particulier la",
  biometricPhoto: 'qualité de la photo biométrique soumise.',
  submitted: '',
  pleaseChooseFile: 'Veuillez choisir un fichier',
  noFileChosen: "Aucun fichier n'a été choisi",
  noUserForEmail:
    "Aucun utilisateur ayant cette adresse électronique n'a été trouvé dans le système.",
  ...terms,
  ...policy,
};



// WEBPACK FOOTER //
// ./src/conf/translations/fr.js